<template>
	<div class="account-pages mt-5 mb-5">
		<div class="container">
			<div class="row justify-content-center">
				<div class="col-lg-5">
					<div class="card">
						<!-- Logo -->
						<div class="card-header pt-4 pb-4 text-center ">
							<router-link to="/">
								<span><img src="@/assets/images/logo/Labodina_logo_hor_black.svg" alt="" height="52"></span>
							</router-link>
						</div>

						<div class="card-body p-4">
							<router-view></router-view>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'EmptyLayout'
};
</script>
